module.exports = __webpack_public_path__ + "img/ic_page-left.60d49b52.svg";